interface FairtouchConfig {
  uri: string
}
export const fairtouchConfig: FairtouchConfig = {
  uri: 'https://d2vdrxov3sh01c.cloudfront.net',
}
